<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1000px"
      title="加工单列表"
      id-key="UserId"
      @close-saved="$emit('close-saved')"
      
    >

        <list ref="list" :temp-params="{status : 3, ProductionType: 1, OrderType}"></list>  

        <div slot="footer">
          <el-button type="primary" @click="saved"  >保存</el-button>
       </div>
      
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import list from "@/views/business/stock/workList/index";



// import iForm from '@/data/sys/user/IForm.json'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    list,
  },
  props: {
    OrderType: {
      type: Number,
      default: 0,
    }

  },
  methods: {
    saved(){
      let list = this.$refs.list.list;
      let subList = this.$refs.list.subList;
      let TradeUnitId = this.$refs.list.TradeUnitId;
      this.$emit('saved', {
        list,
        subList,
        TradeUnitId
      });
      this.close();
    }
  }
  
};
</script>
